<template>
  <div class="edit-dealer pad">
    <div class="pad">
      <dealer-form v-if="dealer" :dealer="dealer" @submitted="submitted" />
    </div>
  </div>
</template>

<script>
import DealerForm from '@/components/DealerForm.vue'
export default {
  name: 'EditDealer',
  components: {
    DealerForm
  },
  data () {
    return {
      dealer: null,
      categories: null
    }
  },
  computed: {
    dealerId () { return this.$route.params.id }
  },
  watch: {
    dealerId () { this.loadDealer() }
  },
  created () {
    this.loadDealer()
  },
  methods: {
    loadDealer () {
      this.$api('getDealer', { id: this.dealerId })
        .then(resp => {
          this.dealer = resp.data
          this.categories = resp.categories
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitted () {
      setTimeout(() => this.$router.push('/dealers'), 300)
    }
  }
}
</script>

<style>

</style>
